import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {selectMultishareHistoryEntries} from './multishare-history.selectors';
import {
  MultishareHistoryFilter,
  MultishareHistoryFilterModel
} from './multishare-history-table/multishare-history-table.component';
import {loadMultishareHistorys} from './multishare-history.actions';

@Injectable({
  providedIn: 'root'
})
export class MultishareHistoryFacadeService {

  constructor(private store: Store) {
  }

  loadMultishareHistoryEntries(value: MultishareHistoryFilterModel, filterWithPage: Partial<MultishareHistoryFilter>) {
    this.store.dispatch(loadMultishareHistorys({
      filter: <MultishareHistoryFilter>{
        ...value,
        page: filterWithPage.page
      }
    }));
  }

  selectMultishareHistoryEntries() {
    return this.store.select(selectMultishareHistoryEntries);

  }
}
